import { Box, Button, Card, CardContent, Grid, Stack, Typography } from "@mui/material";
import { CardProps } from "..";
import { useState } from "react";
import DialogEditarDadosCadastrais from "./DialogEditarDadosCadastrais";
import { DadoValorPrinter } from "../../../../../../../components/BasicComponents/DisplayDados/DadoValorPrinter";
import { formatarCPFCNPJ } from "../../../../../../../helpers/masks";

export default function CardDadosCadastrais({
    data,
}: PropsCardDadosCadastrais) {
    const [openEditar, setOpenEditar] = useState(false);
    return (
        <Card>
            <CardContent>
                <Typography variant="h6" mb={2}>
                    Dados cadastrais
                </Typography>
                <Grid container spacing={3}>
                    <Grid size={{xs: 6, md: 4}}>
                        <DadoValorPrinter titulo="Nome" valor={`${data.nome_pessoa}`} />
                    </Grid>

                    <Grid size={{xs: 6, md: 4}}>
                        <DadoValorPrinter titulo="Email" valor={`${data.email ? data.email : 'N/A'}`} />
                    </Grid>

                    <Grid size={{xs: 6, md: 4}}>
                        <DadoValorPrinter titulo={data.documento_pessoa?.length === 11 ? 'CPF' : 'CNPJ'} valor={`${formatarCPFCNPJ(data.documento_pessoa)}`} />
                    </Grid>
                    <Grid size={{xs: 6, md: 4}}>
                        <DadoValorPrinter titulo="Telefone" valor={`${data.telefone}`} />
                    </Grid>
                    <Grid size={{xs: 6, md: 3}}>
                        <DadoValorPrinter titulo="Cep" valor={`${data.cep}`} />
                    </Grid>
                    <Grid size={{xs: 6, md: 5}}>
                        <DadoValorPrinter titulo="Cidade" valor={`${data.cidade ? `${data.cidade.nome} - ${data.cidade.estado}` : 'N/A'}`} />
                    </Grid>
                    <Grid size={{xs: 6, md: 6}}>
                        <DadoValorPrinter titulo="Endereço" valor={`${data.endereco} ${data.complemento_endereco ?? ""} ${data.numero_endereco}`} />
                    </Grid>
                    <Grid size={{xs: 6, md: 4}}>
                        <DadoValorPrinter titulo="Bairro" valor={`${data.bairro}`} />
                    </Grid>

                </Grid>
                {
                    data.tipo_publico === 'A' &&
                    <Stack>
                        <Box alignSelf={'self-end'}>
                            <Button onClick={() => { setOpenEditar(true) }} variant="outlined" color="primary" size="small" sx={{ mt: 1 }}>
                                Editar
                            </Button>
                        </Box>
                    </Stack>
                }
            </CardContent>
            {
                openEditar &&
                <DialogEditarDadosCadastrais open={openEditar} onClose={() => setOpenEditar(false)} data={data} />
            }
        </Card>
    )
}

interface PropsCardDadosCadastrais extends CardProps {
}
